<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1723N3u/CoverDesign.jpg?1684274658155" alt="This image is the cover for the book Emerald Fires, The Bloodlines Chronicles"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Emerald Fires, The Bloodlines Chronicles
      </h1>
      <p class="bookDescription body article font2">
        <p>Nicola Casimir has a talent for finding trouble, or rather, it finds her. Six months after most of downtown Austin was leveled, her new case with the sexy federal agent assigned as her handler pits her back up against the shadowy forces that almost killed her. <br/> There's no hiding the sparks between them as they navigate their evolving relationship. Old adversaries become new allies. New enemies are unimaginally powerful, and both of them will learn that nothing burns as hot as someone who has nothing to lose.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        S.M. Butler
      </h2>
      
      <p class="authorDescription body article">S.M. Butler is a <i>New York Times</i> and <i>USA Today</i> bestselling author of the <i>Lucky Thirteen SEALs</i> series, the <i>Reapers Strike Force</i> series, and the urban fantasy series <i>the Bloodlines Chronicles</i>. <br><br> She lives in Texas under a not-so-secret identity with two teenaged monsters, writing books, and planning the next step in her evil plans for world domination into the twilight hours of the night because that’s when it’s quiet in the house. She loves to hear from readers. <br><br> In fact, you can connect with S.M. Butler online via her newsletter, Twitter, or Facebook. Or check out her YouTube channel for videos about writing, voice acting, and paper planning/creative journaling.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Soaring Phoenix LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?07ec65ef